import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, Select, Table, Statistic, Tag, Input, message, Button, Tooltip } from 'antd';
import moment from 'moment';
import { useGlobalState } from '../../../store/state';
import { BsFilter } from 'react-icons/bs';
import { VscEye } from 'react-icons/vsc';
import { dateRangeSeperator } from '../../../utils';
import PlatformIconRender from '../../Common/PlatformIconRender';
import { CampaignList } from '../../../apis/Admin/Campaigns/CampaignList';
import { AiOutlineSearch } from 'react-icons/ai';
import { SearchCampaign } from '../../../apis/Admin/Campaigns/SearchCampaign';
import { Link, useParams } from 'react-router-dom';
import './BrandsTableComponent.styles.scss';
import { GetBrandsList } from '../../../apis/Admin/Brands/GetBrandsList';
import { GetCompanyList } from '../../../apis/Admin/Brands/GetCompanyList';
import CurrencyIcon from '../../Common/CurrencyIcon';

const { RangePicker } = DatePicker;
const { Option } = Select;
const BrandsCompaniesTableComponent = () => {
  const params = useParams();
  const [user] = useGlobalState('user');
  // const [company] = useGlobalState('company');
  const [brands, setBrands] = useState({
    searching: false,
    query: '',
    range: [moment().subtract(180, 'days'), moment()],
    filter: 'all',
    pager: {
      page: 1,
      total: 0,
      limit: 10,
    },
    data: [],
  });

  // @note: common function for get transcatioins
  const getCompanyList = (status, page, limit) =>{
    setBrands({
      ...brands,
      query: '',
      filter: status,
      data: [],
    });

    const _data = {
      brandId: params.brandId,
      page: page || 1,
      limit: limit || 10,
    };
    // GetCompanyList(user.accessToken,params.brandId).then(({status,response})=>{
    GetCompanyList(user.accessToken, _data).then(({ status, response })=>{
      console.log('fetched companies', response);
      if (status === 200) {
        setBrands({
          ...brands,
          query: '',
          searching: false,
          pager: {
            ...brands.pager,
            page: response.page,
            limit: response.limit,
            total: response.totalDocs,
          },
          data: response.companies.map((company)=>{
            return {
              key: company._id,
              id: company._id || 'N/A',
              companyname: company.companyname || 'N/A',
              total: company.approved_campaigns.count || 'N/A',
              active: company.active_campaigns.count || 'N/A',
              // type:company.accountType || 'N/A',
              createdAt: moment(company.createdAt).format('Do MMM YYYY'),
              balance: company.credits || 0,
            };
          }),
        });
      }
    });
  };

  useEffect(()=>{
    // const {range,filter,pager:{page}} = txnState
    getCompanyList();
  }, []);


  // @note: table columns setup
  const columns = [
    {
      title: 'Company Name',
      dataIndex: 'companyname',
      render: (v, o) =>(
        <>
          <p className="m-0"><strong>{v} {o.lastname}</strong></p>
          <p className="m-0">{o.id}</p>
        </>
      ),
    },
    {
      with: 100,
      title: 'Total Camapigns',
      dataIndex: 'total',
      align: 'center',
    },
    {
      with: 100,
      title: 'Active Campaigns',
      dataIndex: 'active',
      align: 'center',
    },
    {
      width: 150,
      title: 'Created On',
      dataIndex: 'createdAt',
      align: 'center',
    },
    {
      width: 150,
      title: 'Credit',
      dataIndex: 'balance',
      // align:"center",
      render: (v, o) => <Statistic className="custom_number_format"
        value={v}
        prefix={CurrencyIcon()}
        precision={2}/>,
    },
    {
      title: 'Action',
      key: 'view',
      align: 'center',
      width: 80,
      render: (v, o) => <Link to={`/admin/dashboard/brands/${params.brandId}/companies/${o.id}`}
        className="common_button py-2"
        title="View Campaign"><VscEye/></Link>,
    },
  ];

  // @note: page changing if more than
  const changePage = (page) =>{
    const { pager, filter, query, searching } = brands;
    // getTransactionDetails(range,filter,page)
    // setCamps({
    //     ...camps,
    //     pager:{
    //         ...camps.pager,
    //         page:page
    //     }
    // })
    // if(searching === true){
    //     console.log("query",query)
    //     getCampaignSearchList(query,page,pager.limit)
    // }else{
    getCompanyList(filter, page, pager.limit);
    // }
  };


  // const onSearchCampaign = (query) =>{
  //     // console.log(e)
  //     const {pager} = camps
  //     if(query.length >= 3){
  //         getCampaignSearchList(query,1,pager.limit)
  //     }else{
  //         message.warning("Please Search with Minimum 3 characters")
  //     }
  // }

  // @note reset all table fileters and search
  // const resetAllTable = () =>{
  //     const {pager} = camps
  //     getCampaignList('all',1,pager.limit)
  // }
  // const searchOnChange = (e) =>{
  //     // searchRef.current.state.value = '';
  //     setCamps({
  //         ...camps,
  //         query:e.target.value
  //     })
  // }

  return (
    <div className="common_card p-3 txn_history h-100">
      <div className="row">
        {/* <div className="col-md-4 pl-md-2">
                    <Input.Search onChange={searchOnChange} value={brands.query} className="common_input" placeholder="Search Campaign" enterButton onSearch={onSearchCampaign}/>

                </div> */}
        {/* <div className="col-md-8 text-right">
                    <span>
                        <Tooltip title="Reset Search and filters">
                            <Button className="common_button outlined small" onClick={resetAllTable}>Reset</Button>
                        </Tooltip>
                    </span>
                </div> */}
        <div className="col-md-12 mt-4">
          <Table
            columns={columns}
            dataSource={brands.data || []}
            pagination={{
              current: brands.pager.page,
              total: brands.pager.total,
              showSizeChanger: false,
              showQuickJumper: true,
              onChange: (v) => changePage(v),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BrandsCompaniesTableComponent;
